import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselVoyageViewComponent } from './vessel-voyage-view/vessel-voyage-view.component';
import { VesselVoyageFormComponent } from './vessel-voyage-form/vessel-voyage-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { VesselVoyageRoutingModule } from './vessel-voyage-routing-module';




@NgModule({
  declarations: [
    VesselVoyageViewComponent,
    VesselVoyageFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    VesselVoyageRoutingModule,
    FormsModule, ReactiveFormsModule
  ]
})
export class VesselVoyageModule { }
